import React from 'react'
import PropTypes from 'prop-types'
import { Layout } from 'antd'
import { connect } from 'react-redux'
import { SIDE_NAV_WIDTH, SIDE_NAV_DARK, NAV_TYPE_SIDE } from 'constants/ThemeConstant'
import { Scrollbars } from 'react-custom-scrollbars'
import MenuContent from './MenuContent'

const { Sider } = Layout

export const SideNav = ({
  navCollapsed,
  sideNavTheme,
  routeInfo,
  hideGroupTitle,
  localization = true,
  navType,
  isMobileWindow,
}) => {
  const props = { sideNavTheme, routeInfo, hideGroupTitle, localization }
  return (
    !isMobileWindow &&
    navType === NAV_TYPE_SIDE && (
      <Sider
        className={`side-nav ${sideNavTheme === SIDE_NAV_DARK ? 'side-nav-dark' : ''}`}
        width={SIDE_NAV_WIDTH}
        collapsed={navCollapsed}
      >
        <Scrollbars autoHide>
          <MenuContent type={NAV_TYPE_SIDE} {...props} />
        </Scrollbars>
      </Sider>
    )
  )
}

SideNav.propTypes = {
  navCollapsed: PropTypes.bool.isRequired,
  sideNavTheme: PropTypes.string.isRequired,
  routeInfo: PropTypes.object,
  hideGroupTitle: PropTypes.bool,
  localization: PropTypes.bool,
  navType: PropTypes.string.isRequired,
  isMobileWindow: PropTypes.bool.isRequired
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme, navType, isMobileWindow } = theme
  return { navCollapsed, sideNavTheme, navType, isMobileWindow }
}

export default connect(mapStateToProps)(SideNav)
